import { ErrorCode, ResolverTag } from '@ps/web-core-enums';
import { Translation, useIsDesktop } from '@ps/web-shared-components';
import { translatedLink } from '@ps/web-shared-ui';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTCLI_If_you_have_forgotten_your_PIN_ELL,
  TXTCLI_Please_enter_your_PokerStars_P_ELL,
  TXTMOB_Please_visit_our_Xa_hrefXXN0XX_ELL,
  TXTWCL_A_temporary_PIN_has_been_set_o_ELL,
  TXTWCL_HavenXt_received_your_codeX,
  TXTWCL_If_you_havenXt_received_a_PIN__ELL
} from './PINFormText.messages.json';

interface Props {
  children: React.ReactNode;
  errorCode: ErrorCode;
  handleClick: (e: React.MouseEvent<HTMLAnchorElement>) => Promise<void>;
}

const PINFormText: React.FC<Props> = ({ children, errorCode, handleClick }) => {
  const showKeypadText = useIsDesktop();
  const isPINRequired = errorCode === ErrorCode.PIN_REQUIRED;
  const isTempPINRequired = errorCode === ErrorCode.TEMP_PIN_REQUIRED;
  const isTempSMSPINRequired = errorCode === ErrorCode.TEMP_PIN_REQUIRED_SMS;
  return (
    <>
      {isPINRequired && (
        <p>
          <Translation
            {...(showKeypadText
              ? TXTCLI_Please_enter_your_PokerStars_P_ELL
              : TXTCLI_If_you_have_forgotten_your_PIN_ELL)}
            values={{
              a: translatedLink({ href: '/pin-reset', onClick: handleClick })
            }}
          />
        </p>
      )}
      {(isTempPINRequired || isTempSMSPINRequired) && (
        <span>
          <Translation {...TXTWCL_A_temporary_PIN_has_been_set_o_ELL} />
        </span>
      )}
      {children}
      {isTempSMSPINRequired && (
        <Translation
          tagName="p"
          {...TXTWCL_If_you_havenXt_received_a_PIN__ELL}
          values={{
            a: (msg: React.ReactNode) => (
              <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
            )
          }}
        />
      )}
      {isTempPINRequired && (
        <p>
          <Translation {...TXTWCL_HavenXt_received_your_codeX} />{' '}
          <Translation
            {...TXTMOB_Please_visit_our_Xa_hrefXXN0XX_ELL}
            values={{
              a: (msg: React.ReactNode) => (
                <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
              )
            }}
          />
        </p>
      )}
    </>
  );
};

export default PINFormText;
